import { useEffect } from "react";
import { useGetHomepageQuery } from "v2/store/taxSetupApi";
import { countEntityQuestions } from "v2/utils/taxSetupProgress";

type EntityQuestionCount = { answered: number; total: number };

type EntityProgressProbeProps = {
  groupId: string;

  apiEntityId: string;

  entityId: string;

  seasons: number[];

  currentSeason: number;
  onProgress: (entityId: string, count: EntityQuestionCount) => void;
};

export const EntityProgressProbe = ({
  groupId,
  apiEntityId,
  entityId,
  seasons,
  currentSeason,
  onProgress,
}: EntityProgressProbeProps) => {
  const { data } = useGetHomepageQuery(
    { groupId, entityId: apiEntityId, seasons },
    { skip: !groupId || !apiEntityId }
  );

  const { answered, total } = countEntityQuestions(
    data,
    seasons,
    currentSeason
  );

  const isLoaded = Boolean(data);

  useEffect(() => {
    if (!isLoaded) return;

    onProgress(entityId, { answered, total });
  }, [isLoaded, entityId, answered, total, onProgress]);

  return null;
};
